import React, { useEffect, useState } from "react";
import { FaBriefcase } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Navbar from "../../components/Navbar";
import { API_empleos } from "../../config/apiConfig";
import "./css/NuevoEmpleo.css";
import { useAuth } from "../../context/AuthContext";

const NuevoEmpleo = () => {
  const { token } = useAuth();

  // Form state variables
  const [titulo, setTitulo] = useState("");
  const [sector, setSector] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [direccionSeleccionada, setDireccionSeleccionada] =
    useState("Isla Cristina");
  const [otraDireccion, setOtraDireccion] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [link, setLink] = useState("");
  const [destacadoChecked, setDestacadoChecked] = useState(false);
  const [fechaFinalizacion, setFechaFinalizacion] = useState("");

  const [mostrarModal, setMostrarModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // para edición

  // Cargar datos cuando editamos
  useEffect(() => {
    const cargarDatos = async () => {
      if (!id) return;
      try {
        const response = await fetch(`${API_empleos}/${id}`, {
          headers: {
            "x-auth-token": token,
          },
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const empleo = await response.json();
        // console.log("Datos de la oferta de empleo:", empleo);

        setTitulo(empleo.title || "");
        setSector(empleo.categorySector || "");
        setEmpresa(empleo.company || "");
        setDescripcion(empleo.description || "");
        setLink(empleo.link || "");
        setDestacadoChecked(empleo.isFeatured || false);

        // Manejar la ubicación
        if (empleo.location === "Isla Cristina") {
          setDireccionSeleccionada("Isla Cristina");
          setOtraDireccion("");
        } else {
          setDireccionSeleccionada("otra");
          setOtraDireccion(empleo.location || "");
        }

        // Manejar fecha de finalización si está destacado
        if (empleo.isFeatured && empleo.expirationDate) {
          // Convertir la fecha ISO a formato YYYY-MM-DD para el input date
          const fechaISO = new Date(empleo.expirationDate);
          const fechaFormateada = fechaISO.toISOString().slice(0, 10);
          setFechaFinalizacion(fechaFormateada);
        }
      } catch (error) {
        console.error("Error al cargar la oferta de empleo:", error);
        toast.error("Error al cargar los datos de la oferta de empleo");
      }
    };

    cargarDatos();
  }, [id, token]);

  const handleCancelar = () => {
    setMostrarModal(true);
  };

  const handleSalir = () => {
    navigate("/admin/empleo");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!titulo || !sector ) {
      toast.error("Por favor, rellena todos los campos obligatorios (*)");
      return;
    }

    if (destacadoChecked && !fechaFinalizacion) {
      toast.error(
        "Si marcas como destacado, debes especificar la fecha de finalización"
      );
      return;
    }

    setIsSubmitting(true);

    try {
      const ubicacion =
        direccionSeleccionada === "otra"
          ? otraDireccion
          : direccionSeleccionada;

      const jobOfferData = {
        title: titulo,
        categorySector: sector,
        isFeatured: destacadoChecked,
        location: ubicacion,
        link: link,
        imageUrl: "/images/default-job.jpg", // Default image
        expirationDate:
          destacadoChecked && fechaFinalizacion
            ? new Date(fechaFinalizacion + "T00:00:00.000Z").toISOString()
            : new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString(), // 90 days from now
      };

      // Solo incluir description si tiene valor
      if (descripcion && descripcion.trim() !== "") {
        jobOfferData.description = descripcion;
      }

      // Solo incluir company si tiene valor
      if (empresa && empresa.trim() !== "") {
        jobOfferData.company = empresa;
      }

      // Solo agregar campos de creación si no estamos editando
      if (!id) {
        jobOfferData.publicationDate = new Date().toISOString();
        jobOfferData.initialRegistration = new Date().toISOString();
      }

      const url = id ? `${API_empleos}/${id}` : API_empleos;
      const method = id ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify(jobOfferData),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();

      toast.success(
        id
          ? "Oferta de empleo actualizada correctamente"
          : "Oferta de empleo creada correctamente",
        {
          autoClose: 2000,
        }
      );
      setTimeout(() => navigate("/admin/empleo"), 2000);
    } catch (error) {
      console.error(
        id
          ? "Error al actualizar la oferta de empleo:"
          : "Error al crear la oferta de empleo:",
        error
      );
      toast.error(
        id
          ? "Error al actualizar la oferta de empleo. Por favor, inténtalo de nuevo."
          : "Error al crear la oferta de empleo. Por favor, inténtalo de nuevo."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEliminar = async () => {
    try {
      const res = await fetch(`${API_empleos}/${id}`, {
        method: "DELETE",
        headers: {
          "x-auth-token": token,
        },
      });
      // ... rest of the function remains the same ...
    } catch (error) {
      console.error("Error al eliminar oferta:", error);
      toast.error("Error al eliminar la oferta");
    }
  };

  return (
    <>
      <Navbar />

      <main className="main creacion-ofertas">
        <section className="cabecera between">
          <h1 className="titulo-user align-center">
            {id ? "EDITAR OFERTA DE EMPLEO" : "NUEVA OFERTA DE EMPLEO"}
          </h1>
          {/* <div className="fechas-inscripcion align-center">
              <p className="verde">PLAZOS DE INSCRIPCIÓN:</p>
              <input
                type="date"
                required
              />
              <p>-</p>
              <input
                type="date"
                required
              />
            </div> */}
          <div style={{ height: "60px" }} className="column gap-10">
            <div className="noticias-destacadas align-center">
              <input
                type="checkbox"
                id="terminos"
                aria-label="Colocar en destacados"
                checked={destacadoChecked}
                onChange={(e) => setDestacadoChecked(e.target.checked)}
              />
              <label> Colocar en Destacados</label>
            </div>

            {destacadoChecked && (
              <div className="campo column">
                <label className="verde mayusculas">
                  Fecha de finalización *
                </label>
                <input
                  type="date"
                  aria-label="Fecha de finalización"
                  value={fechaFinalizacion}
                  onChange={(e) => setFechaFinalizacion(e.target.value)}
                  required={destacadoChecked}
                />
              </div>
            )}
          </div>
        </section>

        <section className="flex-1 formulario-alta wrap gap-50">
          <div className="campo column">
            <label className="verde mayusculas">Puesto de trabajo *</label>
            <input
              type="text"
              placeholder="Puesto"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              required
            />
          </div>

          <div className="campo column">
            <label className="verde mayusculas">SECTOR LABORAL *</label>
            <select
              required
              aria-label="Sector al que pertenece la oferta"
              value={sector}
              onChange={(e) => setSector(e.target.value)}
            >
              <option value="" disabled>
                Sector
              </option>
              <option value="AFD">
                Actividades Físicas y Deportivas (AFD)
              </option>
              <option value="ACT">
                Actividades y Competencias Transversales (ACT)
              </option>
              <option value="ADG">Administración y Gestión (ADG)</option>
              <option value="AGA">Agraria (AGA)</option>
              <option value="ARG">Artes Gráficas (ARG)</option>
              <option value="ART">Artes y Artesanías (ART)</option>
              <option value="COM">Comercio y Marketing (COM)</option>
              <option value="EOC">Edificación y Obra Civil (EOC)</option>
              <option value="ELE">Electricidad y Electrónica (ELE)</option>
              <option value="ENA">Energía y Agua (ENA)</option>
              <option value="FME">Fabricación Mecánica (FME)</option>
              <option value="HOT">Hostelería y Turismo (HOT)</option>
              <option value="IMP">Imagen Personal (IMP)</option>
              <option value="IMS">Imagen y Sonido (IMS)</option>
              <option value="INA">Industrias Alimentarias (INA)</option>
              <option value="IEX">Industrias Extractivas (IEX)</option>
              <option value="IFC">Informática y Comunicaciones (IFC)</option>
              <option value="IMA">Instalación y Mantenimiento (IMA)</option>
              <option value="IAD">Inteligencia Artificial y Data (IAD)</option>
              <option value="MAM">Madera, Mueble y Corcho (MAM)</option>
              <option value="MAP">Marítimo-Pesquera (MAP)</option>
              <option value="QUI">Química (QUI)</option>
              <option value="SAN">Sanidad (SAN)</option>
              <option value="SEA">Seguridad y Medio Ambiente (SEA)</option>
              <option value="SSC">
                Servicios Socioculturales y a la Comunidad (SSC)
              </option>
              <option value="TCP">Textil, Confección y Piel (TCP)</option>
              <option value="TMV">
                Transporte y Mantenimiento de Vehículos (TMV)
              </option>
              <option value="VIC">Vidrio y Cerámica (VIC)</option>
            </select>
          </div>

          <div className="campo column">
            <label className="verde mayusculas">Empresa</label>
            <input
              type="text"
              placeholder="Nombre de la empresa"
              value={empresa}
              onChange={(e) => setEmpresa(e.target.value)}
            />
          </div>

          <div className="campo column">
            <label className="verde mayusculas">
              Ubicación del puesto de trabajo *
            </label>

            {/* Selector de dirección */}
            <select
              value={direccionSeleccionada}
              onChange={(e) => setDireccionSeleccionada(e.target.value)}
              aria-label="Ubicación del puesto de trabajo"
              required
            >
              <option value="Isla Cristina" aria-label="Isla Cristina">
                Isla Cristina
              </option>
              <option value="otra" aria-label="Otra dirección">
                Otra dirección
              </option>
            </select>

            {/* Input que se muestra solo si seleccionan "otra" */}
            {direccionSeleccionada === "otra" && (
              <input
                type="text"
                value={otraDireccion}
                onChange={(e) => setOtraDireccion(e.target.value)}
                placeholder="Introduce otra dirección"
                aria-label="Ubicación del puesto de trabajo"
                required
              />
            )}
          </div>

          <div className="textareas wrap w-100">
            <div className="campo column sobre-mi">
              <label className="verde mayusculas">
                DESCRIPCIÓN DE LA oferta
              </label>
              <textarea
                placeholder="Breve descripción..."
                aria-label="Descripción sobre la oferta"
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
              />
            </div>

            <div className="campo column">
              <label className="verde mayusculas">Link de la oferta </label>
              <input
                type="text"
                placeholder="https://www.oferta_empleo.com"
                aria-label="Link a la oferta"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                required
              />
            </div>
          </div>
        </section>

        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column">
              <p>
                {id
                  ? "Si sales de esta página no se guardarán los cambios."
                  : "Si sales de esta página no se creará la oferta de empleo."}
                <br></br>¿Estás seguro que quieres salir?
              </p>
              <div className="botones flex gap-20">
                <button className="fondo-rojo blanco" onClick={handleSalir}>
                  Salir
                </button>
                <button
                  className="seguir blanco fondo-verde"
                  onClick={() => setMostrarModal(false)}
                >
                  {id ? "Seguir editando" : "Seguir creando oferta"}
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="botones flex-center">
          <button
            className="fondo-rojo mayusculas blanco"
            onClick={handleCancelar}
            disabled={isSubmitting}
          >
            Cancelar
          </button>
          <button
            className="descargar mayusculas fondo-verde blanco"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting
              ? id
                ? "Guardando..."
                : "Creando..."
              : id
              ? "Guardar cambios"
              : "Crear nueva oferta"}
          </button>
        </section>
      </main>
    </>
  );
};

export default NuevoEmpleo;
